/**
 * Board Service Headless Pool
 * Using the unified headless pool system from @things-factory/shell
 *
 * 운영 환경 (GPU 없는 EC2 등) 에서는 idle 브라우저 상주 부담이 크다. min=0 으로 두면
 * 사용 안 할 때 메모리 0, 첫 요청 시에만 spawn (~1-2 초 cold start). thumbnail 은
 * fire-and-forget 백그라운드라 cold start 가 사용자 경험에 영향 없다.
 *
 * 환경 변수로 운영자가 조정:
 *   HEADLESS_POOL_BOARD_MIN  (default 0 — 메모리 절약)
 *   HEADLESS_POOL_BOARD_MAX  (default 10)
 */

import { getOrCreateHeadlessPool, HEADLESS_POOL_ARGUMENT_SETS } from '@things-factory/shell'

const POOL_MIN = parseInt(process.env.HEADLESS_POOL_BOARD_MIN ?? '0', 10)
const POOL_MAX = parseInt(process.env.HEADLESS_POOL_BOARD_MAX ?? '10', 10)

// Create the board pool instance
const boardPool = getOrCreateHeadlessPool('board', {
  min: POOL_MIN,
  max: POOL_MAX,
  args: [
    ...HEADLESS_POOL_ARGUMENT_SETS.basic,
    ...HEADLESS_POOL_ARGUMENT_SETS.keychain_safe
  ],
  acquireTimeoutMillis: 15000,
  testOnBorrow: true,
  enableCleanup: true
})

/**
 * Get the board headless pool
 * @returns Pool instance with acquire/release methods
 */
export function getHeadlessPool() {
  return {
    acquire: () => boardPool.acquire(),
    release: (resource: any) => boardPool.release(resource),
    size: 0, // These will be dynamically calculated if needed
    available: 0,
    borrowed: 0,
    pending: 0,
    max: POOL_MAX,
    min: POOL_MIN
  }
}